import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const ProjectHistoryHeader = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 1rem;
  padding: 1.5rem 1.5rem 3rem 1.5rem;
`;

export const TableContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  padding: 1.5rem;
`;
